import { ServicesMenu } from "../components/navbar/flayoutLink";

export const navItems = [
  {
    label: "Home",
    route: "/home",
  },
  {
    label: "About Us",
    route: "/aboutus",
  },
  {
    label: "Services",
    route: "/services",
    flayoutContent: ServicesMenu,
  },
  {
    label: "Projects",
    route: "/projects",
  },
  {
    label: "Blogs",
    route: "/blogs",
  },
  {
    label: "Contact Us",
    route: "/contactus",
  },
  {
    label: "Careers",
    route: "/careers",
  },
];

// Used in FlayoutLink
export const dropDownMenuList = [
  {
    label: "Telecommunication",
    child: [
      {
        label: "Network Benchmark Testing",
        href: "/services/networkBenchmarkTesting",
      },
      {
        label: "Field Performance Testing",
        href: "/services/fieldPerformanceTesting",
      },
      {
        label: "Global Certification Testing",
        href: "/services/globalCertificationTesting",
      },
      {
        label: "SoS Call Testing",
        href: "/services/sosCallsTesting",
      },
    ],
  },
  {
    label: "Infotainment Systems",
    child: [
      {
        label: "GPS Testing",
        href: "/services/gpsTesting",
      },
      {
        label: "Tuner And Media Testing",
        href: "/services/tunerAndMediaTesting",
      },
      {
        label: "HMI Testing",
        href: "/services/hmiTesting",
      },
    ],
  },
  {
    label: "Software Development",
    child: [
      {
        label: "Web Apps Development",
        href: "/services/webAppDev",
      },
      {
        label: "Mobile Apps Development",
        href: "/services/mobileAppDev",
      },
    ],
  },
  {
    label: "Quality Assurance",
    child: [
      {
        label: "Manual Testing",
        href: "/services/manualTesting",
      },
      {
        label: "Automation Testing",
        href: "/services/automationTesting",
      },
      {
        label: "Performance Testing",
        href: "/services/performanceTesting",
      },
      {
        label: "API Testing",
        href: "/services/apiTesting",
      },
    ],
  },
];
